import { reactive } from 'vue'
import { ExtensionProviders, useMindMap } from 'compositions/mindmap'

export const createOpenTopicLinkDialogAction = () => {
  return reactive({
    get isEnabled() {
      const { selection, document } = useMindMap()

      const isMulti = selection.value?.isMulti
      let hasTopicWithAttachmentOrAudioNote: boolean

      selection.value?.modelIds.forEach(modelId => {
        const topicQuery = document.value.query({ id: modelId })?.asTopic()
        if ((topicQuery?.href && topicQuery?.href.startsWith('xap')) || topicQuery?.extensionBy(ExtensionProviders.AudioNotes)) {
          hasTopicWithAttachmentOrAudioNote = true
        }
      })

      return !isMulti && !hasTopicWithAttachmentOrAudioNote
    },
  })
}
